import React from 'react';
import KPICard from './KPICard';

const KPICardDemo: React.FC = () => {
  return (
    <div style={{ padding: '32px', fontFamily: 'Inter, system-ui, sans-serif' }}>
      <div style={{ marginBottom: '32px' }}>
        <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#1f2937', marginBottom: '16px' }}>
          KPICard Component Demo
        </h2>
        <p style={{ color: '#6b7280', marginBottom: '24px' }}>
          Showcase of KPI cards for aquaculture management dashboard
        </p>
      </div>

      {/* Aquaculture KPI Examples */}
      <div style={{ marginBottom: '32px' }}>
        <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#374151', marginBottom: '16px' }}>
          Aquaculture Dashboard KPIs
        </h3>
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', 
          gap: '16px' 
        }}>
          <KPICard
            title="Total Fish Count"
            value={15420}
            unit="fish"
            icon="biomas"
            trend={{ value: 8.5, direction: 'up', period: 'vs last month' }}
            variant="success"
          />
          
          <KPICard
            title="Water Temperature"
            value={24.5}
            unit="°C"
            icon="water"
            trend={{ value: -1.2, direction: 'down', period: 'vs yesterday' }}
            variant="info"
          />
          
          <KPICard
            title="Feed Consumption"
            value={850}
            unit="kg"
            icon="feed"
            trend={{ value: 12.3, direction: 'up', period: 'this week' }}
            variant="warning"
          />
          
          <KPICard
            title="Mortality Rate"
            value={0.8}
            unit="%"
            icon="database"
            trend={{ value: -0.3, direction: 'down', period: 'vs last week' }}
            variant="success"
          />
          
          <KPICard
            title="Growth Rate"
            value={2.4}
            unit="g/day"
            icon="dashboard-chart"
            trend={{ value: 5.7, direction: 'up', period: 'avg' }}
            variant="default"
          />
          
          <KPICard
            title="Active Tasks"
            value={23}
            icon="tasks"
            trend={{ value: 0, direction: 'neutral', period: 'no change' }}
            variant="default"
          />
        </div>
      </div>

      {/* Size Variants */}
      <div style={{ marginBottom: '32px' }}>
        <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#374151', marginBottom: '16px' }}>
          Size Variants
        </h3>
        <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', alignItems: 'flex-start' }}>
          <KPICard
            title="Small Card"
            value={1234}
            unit="units"
            icon="home"
            trend={{ value: 5.2, direction: 'up' }}
            size="sm"
            variant="info"
          />
          
          <KPICard
            title="Medium Card"
            value={5678}
            unit="units"
            icon="dashboard-chart"
            trend={{ value: -2.1, direction: 'down' }}
            size="md"
            variant="warning"
          />
          
          <KPICard
            title="Large Card"
            value={91011}
            unit="units"
            icon="biomas"
            trend={{ value: 15.3, direction: 'up' }}
            size="lg"
            variant="success"
          />
        </div>
      </div>

      {/* Variant Colors */}
      <div style={{ marginBottom: '32px' }}>
        <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#374151', marginBottom: '16px' }}>
          Color Variants
        </h3>
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', 
          gap: '16px' 
        }}>
          <KPICard
            title="Default Style"
            value={1000}
            unit="units"
            icon="database"
            variant="default"
          />
          
          <KPICard
            title="Success Metrics"
            value={850}
            unit="good"
            icon="tasks"
            trend={{ value: 12.5, direction: 'up' }}
            variant="success"
          />
          
          <KPICard
            title="Warning Alert"
            value={45}
            unit="items"
            icon="bell"
            trend={{ value: 8.2, direction: 'up' }}
            variant="warning"
          />
          
          <KPICard
            title="Critical Issue"
            value={3}
            unit="errors"
            icon="settings"
            trend={{ value: -25.0, direction: 'down' }}
            variant="danger"
          />
          
          <KPICard
            title="Information"
            value={2450}
            unit="data"
            icon="chat"
            trend={{ value: 3.1, direction: 'up' }}
            variant="info"
          />
        </div>
      </div>

      {/* Without Trends */}
      <div style={{ marginBottom: '32px' }}>
        <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#374151', marginBottom: '16px' }}>
          Simple KPIs (No Trends)
        </h3>
        <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap' }}>
          <KPICard
            title="Water pH Level"
            value={7.2}
            icon="water"
            variant="info"
          />
          
          <KPICard
            title="Online Users"
            value={156}
            icon="user"
            variant="success"
          />
          
          <KPICard
            title="System Status"
            value="Active"
            icon="settings"
            variant="success"
          />
        </div>
      </div>

      {/* Custom Styling Example */}
      <div style={{ marginBottom: '32px' }}>
        <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#374151', marginBottom: '16px' }}>
          Custom Styled Card
        </h3>
        <div style={{ maxWidth: '300px' }}>
          <KPICard
            title="Premium Feature"
            value="24/7"
            unit="support"
            icon="call"
            trend={{ value: 100, direction: 'up', period: 'uptime' }}
            variant="default"
            style={{
              background: 'linear-gradient(135deg, #08B8D3 0%, #045F6D 100%)',
              border: 'none',
              color: 'white'
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default KPICardDemo;